import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function fakturNotaJasa() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_dashboard/faktur_nota_jasa`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}


function fakturNotaPart() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_dashboard/faktur_nota_part`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}

function driverActive() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_dashboard/driver_active`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}

function vehicleTaxiActive() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_dashboard/vehicle_taxi_active`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}

function vehicleInOutPool() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_dashboard/vehicle_in_out_pool`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}

function vehicleInService() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_dashboard/vehicle_in_service`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}

function traceHold() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_spare_part_masters?filter[stock_menipis]=true`, options)
    .then(response => {
      let dashboard = jsona.deserialize(response.data);
      return dashboard;
    });
}


function spjPaidunpaid(params) {
  //console.log(params.date)
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_dashboard/spj_paid_unpaid/${params.date}`, options)
    .then(response => {
      // console.log(response.data)
      return response.data;
    });
}







export default {
  fakturNotaJasa,
  fakturNotaPart,
  driverActive,
  vehicleTaxiActive,
  vehicleInOutPool,
  vehicleInService,
  traceHold,
  spjPaidunpaid
};

